import withReactContent from "sweetalert2-react-content";
import styles from "./styles.module/PreviewMobile.module.css";
import React from "react";
import Swal from "sweetalert2";
import ExtendedPreview from "./ExtendedPreview";

//Component that contains the preview mobile button.

function PreviewMobile({ firstColor, secondColor }) {
  const showSwal = () => {
    const MySwal = withReactContent(Swal);
    MySwal.fire({
      html: (
        <div
          style={{
            width: "100%",
            height: "100%",
            backgroundColor: "var(--window-color)",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <ExtendedPreview firstColor={firstColor} secondColor={secondColor} />
        </div>
      ),
      showCloseButton: true,
      showCancelButton: false,
      showConfirmButton: false, 
      customClass: {
        popup: "swal2-preview-modal",
      },
      didRender: () => {
        const popup = Swal.getPopup();
        if (popup) {
          popup.style.width = "90vw"; 
          popup.style.maxWidth = "none";
          popup.style.height = "170vw";
          popup.style.backgroundColor = "var(--window-color)";
          popup.style.padding = "0";
          popup.style.overflow = "hidden";
        }
      },
    });
  };
  return (
    <svg
      width="9.16vw"
      height="2.45vw"
      viewBox="0 0 163 47"
      fill="currentColor"
      className={styles.PreviewMobile}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Preview Mobile"
      role="button"
      onClick={showSwal}
    >
      <path
        d="M8 0.5H155C159.142 0.5 162.5 3.85786 162.5 8V39C162.5 43.1421 159.142 46.5 155 46.5H8C3.85787 46.5 0.5 43.1421 0.5 39V8C0.5 3.85786 3.85786 0.5 8 0.5Z"
        fill="#2C2C2C"
      />
      <path
        d="M8 0.5H155C159.142 0.5 162.5 3.85786 162.5 8V39C162.5 43.1421 159.142 46.5 155 46.5H8C3.85787 46.5 0.5 43.1421 0.5 39V8C0.5 3.85786 3.85786 0.5 8 0.5Z"
        stroke="#2C2C2C"
        strokeLinecap="round"
      />
      <path
        d="M52.1667 17.5H42.8333C42.097 17.5 41.5 18.097 41.5 18.8333V28.1667C41.5 28.903 42.097 29.5 42.8333 29.5H52.1667C52.903 29.5 53.5 28.903 53.5 28.1667V18.8333C53.5 18.097 52.903 17.5 52.1667 17.5Z"
        stroke="#F5F5F5"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#2C2C2C"
      />
      <path
        d="M46.1667 20.1667H44.1667V26.1667H46.1667V20.1667Z"
        stroke="#F5F5F5"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M50.8333 20.1667H48.8333V23.5H50.8333V20.1667Z"
        stroke="#F5F5F5"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.9091 29.5V17.8636H68.8409C69.7538 17.8636 70.5 18.0284 71.0795 18.358C71.6629 18.6837 72.0947 19.125 72.375 19.6818C72.6553 20.2386 72.7955 20.8598 72.7955 21.5455C72.7955 22.2311 72.6553 22.8542 72.375 23.4148C72.0985 23.9754 71.6705 24.4223 71.0909 24.7557C70.5114 25.0852 69.7689 25.25 68.8636 25.25H66.0455V24H68.8182C69.4432 24 69.9451 23.892 70.3239 23.6761C70.7027 23.4602 70.9773 23.1686 71.1477 22.8011C71.322 22.4299 71.4091 22.0114 71.4091 21.5455C71.4091 21.0795 71.322 20.6629 71.1477 20.2955C70.9773 19.928 70.7008 19.6402 70.3182 19.4318C69.9356 19.2197 69.428 19.1136 68.7955 19.1136H66.3182V29.5H64.9091ZM74.8835 29.5V20.7727H76.179V22.0909H76.2699C76.429 21.6591 76.7169 21.3087 77.1335 21.0398C77.5502 20.7708 78.0199 20.6364 78.5426 20.6364C78.6411 20.6364 78.7642 20.6383 78.9119 20.642C79.0597 20.6458 79.1714 20.6515 79.2472 20.6591V22.0227C79.2017 22.0114 79.0975 21.9943 78.9347 21.9716C78.7756 21.9451 78.607 21.9318 78.429 21.9318C78.0047 21.9318 77.6259 22.0208 77.2926 22.1989C76.9631 22.3731 76.7017 22.6155 76.5085 22.9261C76.3191 23.233 76.2244 23.5833 76.2244 23.9773V29.5H74.8835ZM84.2301 29.6818C83.3892 29.6818 82.6638 29.4962 82.054 29.125C81.4479 28.75 80.9801 28.2273 80.6506 27.5568C80.3248 26.8826 80.1619 26.0985 80.1619 25.2045C80.1619 24.3106 80.3248 23.5227 80.6506 22.8409C80.9801 22.1553 81.4384 21.6212 82.0256 21.2386C82.6165 20.8523 83.3059 20.6591 84.0938 20.6591C84.5483 20.6591 84.9972 20.7348 85.4403 20.8864C85.8835 21.0379 86.2869 21.2841 86.6506 21.625C87.0142 21.9621 87.304 22.4091 87.5199 22.9659C87.7358 23.5227 87.8438 24.2083 87.8438 25.0227V25.5909H81.1165V24.4318H86.4801C86.4801 23.9394 86.3816 23.5 86.1847 23.1136C85.9915 22.7273 85.715 22.4223 85.3551 22.1989C84.9991 21.9754 84.5786 21.8636 84.0938 21.8636C83.5597 21.8636 83.0975 21.9962 82.7074 22.2614C82.321 22.5227 82.0237 22.8636 81.8153 23.2841C81.607 23.7045 81.5028 24.1553 81.5028 24.6364V25.4091C81.5028 26.0682 81.6165 26.6269 81.8438 27.0852C82.0748 27.5398 82.3949 27.8864 82.804 28.125C83.2131 28.3598 83.6884 28.4773 84.2301 28.4773C84.5824 28.4773 84.9006 28.428 85.1847 28.3295C85.4725 28.2273 85.7206 28.0758 85.929 27.875C86.1373 27.6705 86.2983 27.4167 86.4119 27.1136L87.7074 27.4773C87.571 27.9167 87.3419 28.303 87.0199 28.6364C86.6979 28.9659 86.3002 29.2235 85.8267 29.4091C85.3532 29.5909 84.821 29.6818 84.2301 29.6818ZM96.7543 20.7727L93.527 29.5H92.1634L88.9361 20.7727H90.3906L92.7997 27.7273H92.8906L95.2997 20.7727H96.7543ZM98.5241 29.5V20.7727H99.8651V29.5H98.5241ZM99.206 19.3182C98.9446 19.3182 98.7192 19.2292 98.5298 19.0511C98.3442 18.8731 98.2514 18.6591 98.2514 18.4091C98.2514 18.1591 98.3442 17.9451 98.5298 17.767C98.7192 17.589 98.9446 17.5 99.206 17.5C99.4673 17.5 99.6908 17.589 99.8764 17.767C100.066 17.9451 100.161 18.1591 100.161 18.4091C100.161 18.6591 100.066 18.8731 99.8764 19.0511C99.6908 19.2292 99.4673 19.3182 99.206 19.3182ZM105.98 29.6818C105.139 29.6818 104.414 29.4962 103.804 29.125C103.198 28.75 102.73 28.2273 102.401 27.5568C102.075 26.8826 101.912 26.0985 101.912 25.2045C101.912 24.3106 102.075 23.5227 102.401 22.8409C102.73 22.1553 103.188 21.6212 103.776 21.2386C104.366 20.8523 105.056 20.6591 105.844 20.6591C106.298 20.6591 106.747 20.7348 107.19 20.8864C107.634 21.0379 108.037 21.2841 108.401 21.625C108.764 21.9621 109.054 22.4091 109.27 22.9659C109.486 23.5227 109.594 24.2083 109.594 25.0227V25.5909H102.866V24.4318H108.23C108.23 23.9394 108.132 23.5 107.935 23.1136C107.741 22.7273 107.465 22.4223 107.105 22.1989C106.749 21.9754 106.329 21.8636 105.844 21.8636C105.31 21.8636 104.848 21.9962 104.457 22.2614C104.071 22.5227 103.774 22.8636 103.565 23.2841C103.357 23.7045 103.253 24.1553 103.253 24.6364V25.4091C103.253 26.0682 103.366 26.6269 103.594 27.0852C103.825 27.5398 104.145 27.8864 104.554 28.125C104.963 28.3598 105.438 28.4773 105.98 28.4773C106.332 28.4773 106.651 28.428 106.935 28.3295C107.223 28.2273 107.471 28.0758 107.679 27.875C107.887 27.6705 108.048 27.4167 108.162 27.1136L109.457 27.4773C109.321 27.9167 109.092 28.303 108.77 28.6364C108.448 28.9659 108.05 29.2235 107.577 29.4091C107.103 29.5909 106.571 29.6818 105.98 29.6818ZM113.611 29.5L110.952 20.7727H112.361L114.247 27.4545H114.338L116.202 20.7727H117.634L119.474 27.4318H119.565L121.452 20.7727H122.861L120.202 29.5H118.884L116.974 22.7955H116.838L114.929 29.5H113.611Z"
        fill="var(--optimal-color-text)"
      />
    </svg>
  );
}

export default PreviewMobile;
